<template>
  <div class="rocket-callback-wrapper">
    <div class="callback-container">
      <!-- Loading State -->
      <div v-if="isProcessing" class="processing-state">
        <div class="loader-wrapper">
          <div class="payment-loader">
            <div class="spinner"></div>
          </div>
          <h3 class="processing-title">Processing Payment</h3>
          <p class="processing-text">Please wait while we verify your DBBL Rocket payment...</p>
          <p class="processing-subtext">Do not close this window or press the back button.</p>
        </div>
      </div>

      <!-- Success State -->
      <div v-if="paymentSuccess" class="success-state">
        <div class="success-wrapper">
          <div class="success-icon">
            <i class="fa fa-check-circle"></i>
          </div>
          <h2 class="success-title">Payment Successful!</h2>
          <p class="success-message">Your DBBL Rocket payment has been processed successfully.</p>

          <div class="payment-details">
            <div class="detail-row">
              <span class="detail-label">Bill Number:</span>
              <span class="detail-value">{{ paymentData.bill }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Amount:</span>
              <span class="detail-value">{{ paymentData.amount }} BDT</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Transaction ID:</span>
              <span class="detail-value">{{ paymentData.txn_id }}</span>
            </div>
            <div class="detail-row" v-if="paymentData.approval">
              <span class="detail-label">Approval Code:</span>
              <span class="detail-value">{{ paymentData.approval }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Payment Date:</span>
              <span class="detail-value">{{ paymentData.paid_at }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Unit:</span>
              <span class="detail-value">{{ paymentData.unit }}</span>
            </div>
          </div>

          <div class="action-buttons">
            <!-- <button @click="downloadReceipt" class="btn btn-primary btn-lg">
              <i class="fa fa-download"></i> Download Receipt
            </button> -->

            <button 
                                    class="btn info-btn btn-info radius-1 align-items-center" 
                                    @click="downloadPaySlip({
                                      unit:paymentData.unit,
                                      bill_status:'confirmed',
                                      application_status:paymentData.approval,
                                      bill_number:paymentData.bill,
                                      agent:'rocket',
                                      amount:paymentData.amount,
                                      paid_at:paymentData.paid_at
                                    })"
                                    :disabled="downloadingBills[paymentData.bill]"
                                    type="button"
                                  >
                                    <!-- Icon -->
                                    <i 
                                      :class="downloadingBills[paymentData.bill] ? 'fa fa-spinner fa-spin' : 'fa fa-download'" 
                                      aria-hidden="true"
                                      style="font-size: 1.2em; margin-right: 8px;"
                                    ></i>

                                    <!-- Text -->
                                    <span style="font-size: 0.85rem;">
                                      {{ downloadingBills[paymentData.bill] ? paySlipProgresse : 'Download Payment Receipt' }}
                                    </span>
                                  </button>


            <button @click="goToProfile" class="btn btn-secondary btn-lg">
              <i class="fa fa-user"></i> Go to Profile
            </button>
          </div>
        </div>
      </div>

      <!-- Error State -->
      <div v-if="paymentError" class="error-state">
        <div class="error-wrapper">
          <div class="error-icon">
            <i class="fa fa-times-circle"></i>
          </div>
          <h2 class="error-title">Payment Failed</h2>
          <p class="error-message">Unfortunately, your DBBL Rocket payment could not be completed.</p>

          <div class="error-details">
            <div class="alert alert-danger">
              <strong>Error Reason:</strong><br>
              {{ errorData.reason }}
            </div>
          </div>

          <div class="help-text">
            <h5>What to do next:</h5>
            <ul>
              <li>Please try again after some time</li>
              <li>Ensure you have sufficient balance in your DBBL Rocket account</li>
              <li>Check if you completed the payment on the DBBL gateway</li>
              <li>If the problem persists, contact the helpdesk with the error details above</li>
            </ul>
          </div>

          <div class="action-buttons">
            <button @click="retryPayment" class="btn btn-primary btn-lg">
              <i class="fa fa-refresh"></i> Try Again
            </button>
            <button @click="goToProfile" class="btn btn-secondary btn-lg">
              <i class="fa fa-arrow-left"></i> Back to Profile
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET } from '../../utils/Request'
import { generateReceipt, prepareReceiptDataFromLegacy, RECEIPT_PRESETS } from '../../utils/ReceiptGenerator'
import PayslipGenerator from '@/utils/PayslipGenerator'
export default {
  name: 'RocketCallback',
  data() {
    return {
      isProcessing: true,
      paymentSuccess: false,
      paymentError: false,
      paymentData: {
        bill: '',
        amount: '',
        txn_id: '',
        approval: '',
        paid_at: '',
        unit: '',
        student_name: '',
        father_name: '',
        user_id: ''
      },
      errorData: {
        reason: '',
        code: ''
      },
      transactionId: '',
      callbackToken: '',
      status: '',

      isDownloadingPaySlip: false,
      paySlipProgresse: 'Preparing...',
      downloadingBills: {}
    }
  },
  mounted() {
    // console.log('RocketCallback component mounted');
    this.processCallback();
  },
  methods: {

    async downloadPaySlip(paymentReceipe) {

      const billNumber = paymentReceipe.bill_number

      // Skip if already downloading
      if (this.downloadingBills[billNumber]) return
      // if (this.isDownloadingPaySlip) {
      //   return
      // }

      //this.isDownloadingPaySlip = true
      this.$set(this.downloadingBills, billNumber, true)
      this.paySlipProgresse = 'Preparing...'

      try {
        await PayslipGenerator.generatePayslip(
          {
            name:this.paymentData.student_name,
            father_name:this.paymentData.father_name,
            userID:this.paymentData.user_id
          },
          paymentReceipe,
          'PAID',
          (message, progress) => {
            this.paySlipProgresse = message
          },
          (error) => {
            console.error('Payment Receipet generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate Payment Receipet. Please try again.'
            })
          }
        )

        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'Payment Receipet downloaded successfully!'
        })
      } catch (error) {
        console.error('Payment Receipet download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download Payment Receipet. Please try again.'
        })
      } finally {
        //this.isDownloadingPaySlip = false
        this.$set(this.downloadingBills, billNumber, false)
        this.paySlipProgresse = 'Preparing...'
      }
    },
    async processCallback() {
      try {
        // Get parameters from URL
        const urlParams = new URLSearchParams(window.location.search);
        this.callbackToken = urlParams.get('token') || '';
        this.status = urlParams.get('status') || '';
        const errorCode = urlParams.get('code') || '';

        // console.log('Processing DBBL Rocket callback:', {
        //   hasToken: !!this.callbackToken,
        //   status: this.status,
        //   errorCode: errorCode
        // });

        // Check for error status from backend
        if (this.status === 'error') {
          const errorMessages = {
            'MISSING_TXN_ID': 'Transaction ID is missing. Please try again.',
            'INVALID_TXN_ID': 'Invalid transaction. Please contact support.',
            'SYSTEM_ERROR': 'A system error occurred. Please try again later.'
          };
          const errorReason = errorMessages[errorCode] || 'Payment processing failed';
          this.showError(errorReason, errorCode);
          return;
        }

        // Validate callback token
        if (!this.callbackToken) {
          this.showError('Invalid callback session. Please try again.', 'MISSING_TOKEN');
          return;
        }

        // Retrieve callback data using secure token
        await this.retrieveCallbackData();

      } catch (error) {
        console.error('Callback processing error:', error);
        this.showError('An unexpected error occurred while processing your payment', 'CALLBACK_ERROR');
      }
    },

    async retrieveCallbackData() {
      try {
        // console.log('Retrieving callback data with token...');

        // Call backend API to retrieve callback data
        const response = await GET(`/api/service/dbbl/callback-data?token=${this.callbackToken}`);

        // console.log('Callback data response:', response);

        if (response.status === 200 && response.data.success) {
          const data = response.data.data;

          // Store transaction ID from callback data
          this.transactionId = data.transaction_id;

          // console.log('Callback data retrieved, transaction ID:', this.transactionId);

          // Now verify the payment with backend
          await this.verifyPayment();

        } else {
          this.showError('Unable to retrieve payment information. Session may have expired.', 'RETRIEVE_FAILED');
        }

      } catch (error) {
        console.error('Callback data retrieval error:', error);

        if (error.response && error.response.data) {
          const errorMsg = error.response.data.error || 'Unable to retrieve payment information';
          const errorCode = error.response.data.error_code || 'RETRIEVE_ERROR';
          this.showError(errorMsg, errorCode);
        } else {
          this.showError('Network error. Unable to retrieve payment information.', 'NETWORK_ERROR');
        }
      }
    },

    async verifyPayment() {
      try {
        // console.log('Verifying payment with backend...');

        // Call backend API to verify and complete payment
        const response = await GET(`/api/service/dbbl/verify-payment?trans_id=${this.transactionId}`);

        // console.log('Verification response:', response);

        if (response.status === 200) {
          const data = response.data;

          if (data.success && data.payment_successful) {
            // Payment successful - now includes student information from API
            this.paymentData = {
              bill: data.bill_number || '',
              amount: data.amount || '',
              txn_id: data.transaction_id || this.transactionId,
              approval: data.approval_code || '',
              paid_at: data.paid_at || '',
              unit: data.unit || '',
              student_name: data.student_name || '',
              father_name: data.father_name || '',
              user_id: data.user_id || ''
            };

            this.isProcessing = false;
            this.paymentSuccess = true;

            // console.log('Payment verification successful:', this.paymentData);

          } else {
            // Payment failed or verification failed
            const errorMsg = data.message || data.error || 'Payment verification failed';
            const errorCode = data.error_code || data.result_code || '';
            this.showError(errorMsg, errorCode);
            this.paymentSuccess = false;
          }
        } else {
          this.showError('Unable to verify payment. Please contact helpdesk.', 'VERIFY_FAILED');
            this.paymentSuccess = false;
        }

      } catch (error) {
        console.error('Payment verification error:', error);

        if (error.response && error.response.data) {
          const errorMsg = error.response.data.message || error.response.data.error || 'Payment verification failed';
          const errorCode = error.response.data.error_code || '';
          this.showError(errorMsg, errorCode);
        } else {
          this.showError('Network error. Unable to verify payment. Please check your connection.', 'NETWORK_ERROR');
        }
      }
    },

    showError(reason, code = '') {
      this.isProcessing = false;
      this.paymentError = true;
      this.errorData.reason = reason;
      this.errorData.code = code;
      console.error('Payment error:', { reason, code });
    },

    async downloadReceipt() {
      // console.log('Downloading receipt...');
      // console.log('Payment data:', this.paymentData);

      try {
        // Prepare receipt data with student information
        const receiptData = prepareReceiptDataFromLegacy({
          name: this.paymentData.student_name,
          father_name: this.paymentData.father_name,
          userID: this.paymentData.user_id,
          bill_number: this.paymentData.bill,
          amount: this.paymentData.amount,
          txn_id: this.paymentData.txn_id,
          approval: this.paymentData.approval,
          paid_at: this.paymentData.paid_at,
          unit: this.paymentData.unit,
          agent: 'DBBL Rocket',
          status: 'PAID'
        });

        // console.log('Prepared receipt data:', receiptData);

        // Generate and download PDF with Rocket branding
        await generateReceipt(
          receiptData,
          RECEIPT_PRESETS.ROCKET,
          `cu_payment_receipt_rocket_${this.paymentData.bill}.pdf`
        );

        // console.log('Receipt downloaded successfully');
      } catch (error) {
        console.error('Error generating receipt:', error);
        alert('Failed to generate receipt. Please try again.');
      }
    },

    retryPayment() {
      // console.log('Retrying payment...');
      // Redirect to profile to retry payment
      this.$router.push('/profile');
    },

    goToProfile() {
      // console.log('Navigating to profile...');
      // Clean URL and redirect to profile
      this.$router.push('/profile');
    }
  }
}
</script>

<style scoped>
.rocket-callback-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.callback-container {
  width: 100%;
  max-width: 700px;
}

/* Loading State */
.processing-state {
  background: white;
  border-radius: 15px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.payment-loader {
  margin-bottom: 30px;
}

.spinner {
  width: 80px;
  height: 80px;
  border: 8px solid #f3f3f3;
  border-top: 8px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.processing-title {
  color: #333;
  margin-bottom: 15px;
  font-size: 28px;
  font-weight: 600;
}

.processing-text {
  color: #666;
  font-size: 18px;
  margin-bottom: 10px;
}

.processing-subtext {
  color: #999;
  font-size: 14px;
  font-style: italic;
}

/* Success State */
.success-state {
  background: white;
  border-radius: 15px;
  padding: 50px 40px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.success-icon {
  margin-bottom: 25px;
}

.success-icon i {
  font-size: 80px;
  color: #28a745;
}

.success-title {
  color: #28a745;
  font-size: 32px;
  margin-bottom: 15px;
  font-weight: 700;
}

.success-message {
  color: #666;
  font-size: 18px;
  margin-bottom: 35px;
}

.payment-details {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
  text-align: left;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #dee2e6;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 600;
  color: #495057;
}

.detail-value {
  color: #212529;
  font-weight: 500;
}

/* Error State */
.error-state {
  background: white;
  border-radius: 15px;
  padding: 50px 40px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.error-icon {
  margin-bottom: 25px;
}

.error-icon i {
  font-size: 80px;
  color: #dc3545;
}

.error-title {
  color: #dc3545;
  font-size: 32px;
  margin-bottom: 15px;
  font-weight: 700;
}

.error-message {
  color: #666;
  font-size: 18px;
  margin-bottom: 30px;
}

.error-details {
  margin-bottom: 30px;
  text-align: left;
}

.error-details .alert {
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 8px;
}

.help-text {
  text-align: left;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 30px;
}

.help-text h5 {
  color: #495057;
  margin-bottom: 15px;
  font-weight: 600;
}

.help-text ul {
  color: #666;
  line-height: 1.8;
  padding-left: 20px;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.action-buttons .btn {
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.action-buttons .btn-primary {
  background: #667eea;
  color: white;
}

.action-buttons .btn-primary:hover {
  background: #5568d3;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.action-buttons .btn-secondary {
  background: #6c757d;
  color: white;
}

.action-buttons .btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(108, 117, 125, 0.4);
}

/* Responsive */
@media (max-width: 768px) {
  .rocket-callback-wrapper {
    padding: 10px;
  }

  .processing-state,
  .success-state,
  .error-state {
    padding: 30px 20px;
  }

  .processing-title,
  .success-title,
  .error-title {
    font-size: 24px;
  }

  .processing-text,
  .success-message,
  .error-message {
    font-size: 16px;
  }

  .spinner {
    width: 60px;
    height: 60px;
  }

  .success-icon i,
  .error-icon i {
    font-size: 60px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-buttons .btn {
    width: 100%;
  }

  .detail-row {
    flex-direction: column;
    gap: 5px;
  }
}
</style>
